const SectionSetting = (props) => {
    const { disable } = props;

    return <div className="cards-setting-icon" style={!disable ? {} : { backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />
}

export default SectionSetting;